import { selectableSurfaceVariants } from '@/components/patterns/selectable-surface'
import { cn } from '@/lib/utils'
import type { VariantProps } from 'class-variance-authority'
import type { ComponentProps } from 'react'

export type ActionSurfaceProps = ComponentProps<'button'> &
  VariantProps<typeof selectableSurfaceVariants>

function ActionSurface({
  appearance = 'default',
  className,
  padding = 'default',
  radius = 'surface',
  type = 'button',
  ...props
}: ActionSurfaceProps) {
  return (
    <button
      {...props}
      type={type}
      data-slot="action-surface"
      className={cn(
        selectableSurfaceVariants({ appearance, padding, radius }),
        'inline-flex items-start justify-start gap-3 whitespace-normal text-left',
        className
      )}
    />
  )
}

export { ActionSurface }
